<div class="pag-container">

  <app-kv-breadcrumb [arrayBreadcrumbs]="breadcrumbs"></app-kv-breadcrumb>

  <div class="ui-g-12">
    <app-campaign-3-kontable #table id="audit-rules-table" [columns]="[
      {field: 'id', title: '#', filterType: noFilter, sortable: false},
      {field: 'code', title: 'audit.codeRule'},
      {field: 'auditRulesTypeId', title: 'audit.eventTipology',
           bodyTemplate: ruleTypeTemplateRow ,filterType: selectCustomFilter,filterTemplate: ruleTypeTemplateFilterCol},
      {field: 'eventAuditTable', title: 'audit.eventTable' },
      {field: 'description', title: 'audit.ruleDescription' },
      {field: 'dtDateStart', title: 'audit.ruleDateStart', type: 'date', filterType: dateFilter},
      {field: 'dtDateEnd', title: 'audit.ruleDateEnd', type: 'date', filterType: dateFilter},
      {field: 'flgDeploy', title: 'audit.stateStatusRule',
           bodyTemplate: statusTemplateRow ,filterType: selectFilter, filterOptions: {values: statusList}}
      ]" [fetchActionListAsap]="true" [service]="rulesService" [paginationType]="paginationType"
      [showRecoverButton]="false" [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false"
      [showDetailsButton]="false" [showEditButton]="false" [additionalRowCommands]="actions" [showGlobalFilter]="true"
      [filterBySingleColumn]="false" [expandTable]="false">


      <ng-template #ruleStatusTemplateFilterCol let-col>
        <p-dropdown [options]="statusList" (onChange)="changeStatusRule(col, $event)"
          [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>
      <ng-template #ruleTypeTemplateFilterCol let-col>
        <p-dropdown [options]="actionsRulesTypeCombo"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"
          [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>
      <ng-template #ruleTypeTemplateRow let-row>
        <span>{{getRuleType(row)}}</span>
      </ng-template>

      <ng-template #statusTemplateRow let-row>
        <span class="green-dot" *ngIf="row.flg_state === '0' && row.flg_dpl === '0'"></span>
        <span *ngIf="row.flg_state === '0' && row.flg_dpl === '0'">
          {{'audit.ruleActive' | translate}}
        </span>
        <span *ngIf="row.flg_state=== '1' && row.flg_dpl === '0'">
          {{'audit.ruleDeleted' | translate}}
        </span>
        <span *ngIf="row.flg_state=== '0' && row.flg_dpl === '1'">
          {{'audit.ruleDeactive' | translate}}
        </span>
      </ng-template>

      <ng-template #eventIDTemplate let-row>
        <span>{{ row.auditRulesTypeId.description }}</span>
      </ng-template>

      <ng-template #typeRuleList data-testid="typeRuleList" let-row>
        <span style="text-transform: uppercase;">{{ getDescription(row) }}</span>
      </ng-template>

      <ng-template #actions let-row>
        <div class="detail-btn-container">
          <button class="btn-details" pTooltip="{{ 'audit.modifyNewRule' | translate }}"
            *ngIf="row.flg_state === '0' && row.flg_dpl === '0'" (click)="onModifyAddRule(row.id)">
            <i class="pi pi-pencil icon-size"></i>
          </button>
          <button class="btn-details" pTooltip="{{ 'common.delete' | translate }}" *ngIf="row.flg_state === '0' "
            (click)="onRemoveAddRule(row.id)">
            <i class="pi pi-trash icon-size"></i>
          </button>
          <button class="btn-details" pTooltip="{{ 'audit.ruleActive' | translate }}" *ngIf="row.flg_state === '3'"
            (click)="onDetailsLinkUnLinkRule(row.id)">
            <i class="pi pi-lock icon-size"></i>
          </button>
          <button class="btn-details" pTooltip="{{ 'audit.ruleDeactive' | translate }}"
            *ngIf="row.flg_state === '0' && row.flg_dpl === '0'" (click)="onDetailsLinkUnLinkRule(row.id)">
            <i class="pi pi-lock-open icon-size"></i>
          </button>
          <button class="btn-details" pTooltip="{{ 'audit.detailsRule' | translate }}" (click)="onInfoAddRule(row.id)">
            <i class="pi pi-eye icon-size"></i>
          </button>
          <button class="btn-details" pTooltip="{{ 'common.recover' | translate }}" *ngIf="row.flg_state === '1'"
            (click)="onRecoverAddRule(row.id)">
            <i class="fa fa-undo icon-size"></i>
          </button>
        </div>
      </ng-template>
    </app-campaign-3-kontable>
    <div class="ui-g-12 text-center">
      <button pButton type="button" class="layoutDefaultFirstBtn" icon="fa fa-edit" iconPos="left"
        label="{{'audit.addNewRule' | translate}}" (click)="onClickAddRule()"></button>
      <br />
      <br />
    </div>
  </div>
  <div *ngIf="showPopupInfoInsideTable">
    <p-dialog id="detailRule" header="{{ 'audit.ruleDetail' | translate }}" [(visible)]="showPopupInfoInsideTable"
      [modal]="true" [style]="{width: '90vw', height: '110vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfo()">
      <div class="ui-g-12" id="detailRuleContent">
        <div style="margin-bottom: 5%; margin-top: 5%;">
          <div style="margin-bottom: 5%;">{{ 'audit.accumulatore' | translate }} : <strong>{{
              auditRuleObject.rule.accumulatore }}</strong></div>
          <div style="margin-bottom: 5%;">{{ 'audit.cluster' | translate }} : <strong>{{ auditRuleObject.rule.cluster
              }}</strong></div>
          <div style="margin-bottom: 5%;">{{ 'audit.anagrafica' | translate }} : <strong>{{
              auditRuleObject.rule.anagrafica }}</strong></div>
        </div>
      </div>
    </p-dialog>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/audit/rules/rules.component.html